var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"title":_vm.softDelete ? 'Abandonner' : 'Supprimer',"icon-left":_vm.softDelete ? 'archive-outline' : 'trash-can-outline',"loading":_vm.loading},on:{"click":_vm.onDelete}})}
var staticRenderFns = []

export { render, staticRenderFns }